// import XLSX from 'xlsx';
import { saveAs } from "file-saver";
import i18n from "@/lang";
import formatter from "@/utils/formatter";
import Vue from "vue";
import _ from "lodash";
import * as XLSX from "sheetjs-style";
// const XLSXStyle = require("xlsx-style");

const parseColIndex = (column) => {
  let ids = column._id.split("_");
  if (ids.length == 1) {
    return ids[0];
  }

  let [colIndex, subIndex] = ids;

  return parseInt(colIndex) + parseInt(subIndex);
};

const s2ab = (s) => {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
};

const defaultOptions = {
  s: {
    alignment: { vertical: "center", horizontal: "center", wrapText: true },
  },
};

const parseCell = (c, r) => {
  return XLSX.utils.encode_col(c) + XLSX.utils.encode_row(r);
};

const renderSlot = (column, row) => {
  const SlotCom = Vue.extend(column.xlsx.component);
  let slot = new SlotCom({
    propsData: {
      column: column,
      row: row,
    },
  });

  return slot.$mount();
};
function parseCellOption(column, value) {
  let opt = {};

  if (column.isAccounts == true) {
    if (value < 0) {
      opt.s = { font: { color: { rgb: "B8382C" } } };
    } else if (value > 0) {
      opt.s = { font: { color: { rgb: "3b9300" } } };
    }
  }

  if (column.format) {
    opt.s = { ...opt.s, ...formatter.toXlsxFmt(column.format) };
  }

  if (!isNaN(value)) {
    opt.t = "n";
  }

  if (column.xlsx && column.xlsx.options) {
    opt = _.extend({}, column.xlsx.options, opt);
  }

  return _.extend({}, defaultOptions, opt);
}

function buildWS(wss, columns, sr, er) {
  let c = 0;
  wss = Object.assign({}, wss);
  columns.forEach((column) => {
    if (column.type !== "selection") {
      for (let n = sr; n < er; n++) {
        let cell = parseCell(c, n);
        if (wss[cell]) {
          const opt = parseCellOption(column, wss[cell].v || "");

          wss[cell] = {
            ...wss[cell],
            ...defaultOptions,
            ...opt,
          };
        }
      }
      c++;
    }
  });
  return wss;
}

const makeSheet = (headerRow, allColumns, data, summaryData) => {
  let merge = [];
  let ws = { bookType: "xlsx", bookSST: false, type: "binary" };
  let hasSelection = false;

  headerRow.forEach((columns, rowIndex) => {
    let row = [];
    // sheet col num
    let col = 0;

    columns.forEach((column) => {
      if (column.type !== "selection") {
        let colSpan = column.colSpan - 1;
        let rowSpan = column.rowSpan - 1;

        // current column index
        let colIndex = parseInt(parseColIndex(column, col));

        if (col === 0 && col != column._id) {
          col = hasSelection ? colIndex - 1 : colIndex;
        }

        let s = { r: rowIndex, c: col };
        let e = { r: rowIndex + rowSpan, c: s.c + colSpan };
        let hasMerge = rowSpan > 0 || colSpan > 0;

        col += column.colSpan;

        let isThirdPartyCol =
          "third_party" in column && column.third_party.length > 0;

        let title = column.langKey
          ? i18n.t("column." + column.langKey, {
              third_party: isThirdPartyCol
                ? i18n.t("column." + column.third_party)
                : "",
            })
          : column.title || "";

        row.push(title);

        if (hasMerge === true) {
          merge.push({ s, e });
        }
        XLSX.utils.sheet_add_json(ws, [[title]], {
          skipHeader: true,
          origin: s,
        });
      } else {
        hasSelection = true;
      }
    });
  });

  ws["!merges"] = merge;

  let r = headerRow.length;

  data.forEach((row) => {
    let rowData = {};

    allColumns.forEach((column) => {
      if (column.type === "selection") {
        return;
      }

      let value = column.name in row ? row[column.name] : "";

      if (
        "default" in column &&
        (typeof value == "undefined" ||
          null == value ||
          (typeof value == "string" && !value))
      ) {
        value = column.default;
      }

      if (column.xlsx && column.xlsx.component) {
        let context = renderSlot(column, row);
        value = context.$el.innerHTML;
      }

      // null時為空
      rowData[column.name] = value == null ? "" : value;
    });

    XLSX.utils.sheet_add_json(ws, [rowData], {
      skipHeader: true,
      origin: { r: r, c: 0 },
    });
    r++;
  });

  if (summaryData) {
    let total = {};
    let frst = true;
    allColumns.forEach((column) => {
      if (column.type === "selection") {
        return;
      }
      if (frst) {
        total["label"] = i18n.t("component.table.summary");
        frst = false;
      } else {
        let val =
          typeof summaryData[column.name] == "undefined" ||
          null == summaryData[column.name]
            ? ""
            : summaryData[column.name];

        if (column.amount == false) {
          val = "";
          // } else {
          //   if (column.format) {
          //     val = formatter.format(val, column.format);
          //   }
        }

        total[column.name] = val;
      }
    });
    XLSX.utils.sheet_add_json(ws, [total], {
      skipHeader: true,
      origin: { r: r, c: 0 },
    });
    r++;
  }

  // ws["!merges"].forEach((item) => {
  //   let cell = parseCell(item.s.c, item.s.r);
  //   ws[cell] = Object.assign({}, ws[cell], defaultOptions);
  // });

  ws["!cols"] = [];
  let c = 0;
  allColumns.forEach((column) => {
    if (column.type !== "selection") {
      let wpx = column.width ? column.width : 100;
      ws["!cols"].push({ wpx });
      for (let n = 0; n < headerRow.length; n++) {
        let cell = parseCell(c, n);
        ws[cell] = Object.assign({}, ws[cell], defaultOptions);
      }
      c++;
    }
  });

  ws = buildWS(ws, allColumns, headerRow.length, r);

  return ws;
};

const exportExcel = (sheet, fileName, sheetName = "sheet1") => {
  let wb = {
    SheetNames: [sheetName],
    Sheets: {
      [sheetName]: sheet,
    },
  };

  let wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

  fileName = fileName + ".xlsx" || new Date().getTime() + ".xlsx";
  saveAs(new Blob([s2ab(wbout)], { type: "" }), fileName);
};

const sheetGeneral = (calback) => {
  return calback({ parseCell, exportExcel, XLSX });
};
export default {
  makeSheet,
  exportExcel,
  sheetGeneral,
};
